// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__xyjEV","productName":"Table_productName__2oxUB"};